export default {
    layout: {
        default: [
            "\u0636 \u0635 \u0691 \u0688 \u063A \u0621 \u062E {bksp}",
            "\u0642 \u0648 \u0639 \u0631 \u062A \u06D2 \u0649 \u06C1 \u067E",
            "\u0627 \u0633 \u062F \u0641 \u06AF \u062D \u062C \u06A9 \u0644",
            "\u0632 \u0634 \u0686 \u0637 \u0628 \u0646 \u0645",
            "\u0630 \u062B {space} \u06BA \u0638",
        ],
    },
};
